import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { share } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private userService: AuthService,
        private env: EnvService,
        private router: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.url !== this.env.API_URL + 'users/authenticate') {
            const user =  this.userService.getUser();

            req = req.clone({
                headers: req.headers.append('Authorization', 'Bearer ' + user.token)
                                    .append('X-SiteTraxx-UserId', user.id)
                                    .append('X-SiteTraxx-SiteId', user.siteId)
            });
        }
        return next.handle(req).pipe(share())
                    .pipe((event) => { 
                      event.subscribe(null, error => console.error(error));
                      return event;
                    });
    }
}
